// extracted by mini-css-extract-plugin
export default {"inclusion_cont":"Inclusion_inclusion_cont__jdPey","inclusion_cont_1":"Inclusion_inclusion_cont_1__hybkw"};